import { GetStaticProps } from "next";
import { getAllPosts, type PostMeta } from "~/lib/mdx";
import {
  buildDefaultSolutionsSections,
  createSolutionsPage,
} from "~/components/solutions/solutionsPageFactory";
import { SolutionsForPropertyManagersContent as content } from "~/content/dla-zarzadcow-nieruchomosci/content.pl";
import InfoLinks from "~/components/InfoLinks";

const selectedId = [111, 112, 113, 114, 115];

const sections = buildDefaultSolutionsSections(content, <InfoLinks />);

export default createSolutionsPage({
  content,
  faqSelectedIds: selectedId,
  sections,
});

export const getStaticProps: GetStaticProps<{ recentPosts: PostMeta[] }> = async () => {
  const recentPosts = getAllPosts().slice(0, 3);
  return { props: { recentPosts } };
};
